import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Game from './Game';
import HowToPlay from './HowToPlay';
import Settings from './Settings';
import Setup from './Setup';
import { useTheme } from './useTheme';
import { useEffect } from 'react';

function App() {
	const [theme] = useTheme();
	useEffect(() => {
		if (theme) document.documentElement.setAttribute('data-theme', theme);
		else document.documentElement.removeAttribute('data-theme');
	}, [theme]);

	return (
		<BrowserRouter>
			<Routes>
				<Route path="/how-to-play" element={<HowToPlay />} />
				<Route path="/settings" element={<Settings />} />
				<Route path="/game" element={<Game />} />
				<Route path="/" element={<Setup />} />
			</Routes>
		</BrowserRouter>
	);
}

export default App;
